import { gsap } from 'gsap';
import gsapCore from 'gsap/gsap-core';
import Scrolltrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(Scrolltrigger);
gsap.config({ nullTargetWarn: false });

// スクロール制御の関数
function disableScroll() {
  $('body').addClass('is-menuopened');
  $('body').css('overflow', 'hidden');
}

function enableScroll() {
  $('body').removeClass('is-menuopened');
  $('body').css('overflow', '');
}

let lastWindowWidth = $(window).width();
const breakpoint = 768;

// メニューの初期状態を設定
gsap.set('.sp-header .menu', {
  opacity: 0,
  visibility: 'hidden'
});

gsap.set('.inquiry-menu', {
  opacity: 0,
  visibility: 'hidden'
});

// メニュー状態
let menuOpen = false;

// メニューを閉じる共通関数
function closeSpMenu() {
  const $menuBtn = $('.menu-btn');
  const $menu = $('.menu');

  menuOpen = false;

  $menuBtn.removeClass('is-active');
  $('.menu-trigger').removeClass('active');
  enableScroll();

  return gsap.to($menu, {
    opacity: 0,
    duration: 0.2,
    onComplete: () => {
      gsap.set($menu, { visibility: 'hidden' });
    }
  });
}

// SPメニューボタン
$('.menu-btn').on('click', function () {
  const $menu = $('.menu');
  const $menuBtn = $(this);

  if (!menuOpen) {
    // OPEN
    menuOpen = true;
    $menuBtn.addClass('is-active');
    $('.menu-trigger').addClass('active');
    disableScroll();

    gsap.to($menu, {
      opacity: 1,
      visibility: 'visible',
      duration: 0.2
    });

  } else {
    // CLOSE
    closeSpMenu();
  }

  return false;
});


// ★ 追加部分 ★
// メニュー内リンククリックで閉じる（アンカー処理はそのまま）
$('.menu a').on('click', function () {
  if ($(window).width() <= breakpoint && menuOpen) {
    closeSpMenu();
  }
});



